import { useEffect, useState } from "react";
import { useUser } from "../Context";
import Loading from "./Loading";
import { collection, doc, onSnapshot, query, updateDoc, where } from "firebase/firestore";
import { db } from "../Firebase";
import tick from "../Assets/check.png"
import { toast } from "react-toastify";

export default function AdminDashboard() {
    const [lessees, setLessees] = useState([]);
    const { loading, setLoading } = useUser()

    // useEffect(() => {
    //     setLoading(true);
    //     const unsubscribe = db.collection('lessee')
    //         .where('adminAuthorization', '==', false)
    //         .onSnapshot(snapshot => {
    //             const lesseeData = [];
    //             snapshot.forEach(doc => {
    //                 lesseeData.push({ id: doc.id, ...doc.data() });
    //             });
    //             setLessees(lesseeData);
    //         });
    //     setLoading(false);
    //     return () => unsubscribe();
    // }, []);

    useEffect(() => {
        const unsubscribe = onSnapshot(
            query(collection(db, 'lessee'), where('adminAuthorization', '==', false)),
            (snapshot) => {
                const lesseeData = [];
                snapshot.forEach((doc) => {
                    lesseeData.push({ id: doc.id, ...doc.data() });
                });
                setLessees(lesseeData);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    async function handleApproval(id) {
        try {
            await updateDoc(doc(db, "lessee", id), {
                adminAuthorization:true
            })
            toast.success("User authorized.")
        } catch (error) {
            console.log("Error in authorizing user.")
            toast.error("Error in authorizing user");
        }
    }

    return (
        <>
            {loading ? <Loading /> :
                <main className="w-screen h-auto px-24 p-6">
                    {lessees.length===0?<p className="text-xl font-light text-gray-500">No user waiting for authorization.</p>:<>
                    <h1 className="text-3xl font-medium w-fit antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Users waiting for admin authorization</h1>
                    <div className="mt-4 px-4 max-h-[70vh] overflow-y-auto grid grid-flow-row grid-cols-2 gap-6">
                        {lessees.map(lessee => (
                            <div key={lessee.id} className="border p-2 px-4 items-center rounded-lg shadow-md flex">
                                <div className="w-11/12 flex flex-col gap-2">
                                    <div className="flex gap-2 items-center text-gray-600 text-lg">
                                        <h2 className="text-lg font-medium capitalize antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Name :</h2>
                                        {lessee.name}
                                    </div>
                                    <div className="flex gap-2 items-center text-gray-600 text-lg">
                                        <h2 className="text-lg font-medium capitalize antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Company :</h2>
                                        {lessee.companyName}
                                    </div>
                                    <div className="flex gap-2 items-center text-gray-600 text-lg">
                                        <h2 className="text-lg font-medium capitalize antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Phone :</h2>
                                        {lessee.phoneNumber}
                                    </div>
                                    <div className="flex gap-2 items-center text-gray-600 text-lg">
                                        <h2 className="text-lg font-medium capitalize antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Address :</h2>
                                        {lessee.address}
                                    </div>
                                    <div className="flex gap-2 items-center text-gray-600 text-lg">
                                        <h2 className="text-lg font-medium capitalize antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">email :</h2>
                                        {lessee.email}
                                    </div>
                                </div>
                                    <img onClick={()=>{handleApproval(lessee.id)}} className="w-1/12 rounded-full bg-sky-300 cursor-pointer hover:shadow-lg transition-all hover:shadow-gray-300 p-2" src={tick} alt="tick"/>
                            </div>
                        ))}
                    </div>
                    </>
                    }
                </main>
            }
        </>
    )
}